module.exports = __webpack_public_path__ + "img/assurance.219e9567.svg";